import { defineMessages } from 'react-intl';

export const ExportSettingsMessages = defineMessages({
  header: {
    id: 'administration.tab.exportSettings.header',
    defaultMessage: 'Export Settings',
  },

  // Unified Export Settings
  exportSettingsTitle: {
    id: 'administration.tab.exportSettings.exportSettingsTitle',
    defaultMessage: 'Export Styling',
  },
  exportSettingsDescription: {
    id: 'administration.tab.exportSettings.exportSettingsDescription',
    defaultMessage:
      'Customize the appearance of PDF and Excel exports. These settings will be applied to both export formats.',
  },

  // Table Headers
  tableHeadersLabel: {
    id: 'administration.tab.exportSettings.tableHeadersLabel',
    defaultMessage: 'Table Headers',
  },
  tableRowsLabel: {
    id: 'administration.tab.exportSettings.tableRowsLabel',
    defaultMessage: 'Table Rows',
  },
  tableSummaryLabel: {
    id: 'administration.tab.exportSettings.tableSummaryLabel',
    defaultMessage: 'Table Summary',
  },

  // Style Properties
  fontColorLabel: {
    id: 'administration.tab.exportSettings.fontColorLabel',
    defaultMessage: 'Font Color',
  },
  backgroundColorLabel: {
    id: 'administration.tab.exportSettings.backgroundColorLabel',
    defaultMessage: 'Background Color',
  },
  fontFamilyLabel: {
    id: 'administration.tab.exportSettings.fontFamilyLabel',
    defaultMessage: 'Font Family',
  },
  boldLabel: {
    id: 'administration.tab.exportSettings.boldLabel',
    defaultMessage: 'Bold',
  },
  italicLabel: {
    id: 'administration.tab.exportSettings.italicLabel',
    defaultMessage: 'Italic',
  },

  // Font Families
  fontFamilyRoboto: {
    id: 'administration.tab.exportSettings.fontFamilyRoboto',
    defaultMessage: 'Roboto',
  },
  fontFamilyArial: {
    id: 'administration.tab.exportSettings.fontFamilyArial',
    defaultMessage: 'Arial',
  },
  fontFamilyTimes: {
    id: 'administration.tab.exportSettings.fontFamilyTimes',
    defaultMessage: 'Times New Roman',
  },
  fontFamilyCourier: {
    id: 'administration.tab.exportSettings.fontFamilyCourier',
    defaultMessage: 'Courier New',
  },
  fontFamilyHelvetica: {
    id: 'administration.tab.exportSettings.fontFamilyHelvetica',
    defaultMessage: 'Helvetica',
  },

  // API Messages
  apiSaveDataSuccess: {
    id: 'administration.tab.exportSettings.apiSaveDataSuccess',
    defaultMessage: 'Export settings successfully saved',
  },
  apiSaveDataError: {
    id: 'administration.tab.exportSettings.apiSaveDataError',
    defaultMessage: 'Failed to save export settings. Please try again.',
  },
  apiLoadDataError: {
    id: 'administration.tab.exportSettings.apiLoadDataError',
    defaultMessage: 'Failed to load export settings. Please try again.',
  },
});
